import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import React, { useContext, useState } from "react";
import { AppContextType } from "../../context/app-context";
import SearchFilter from "../search-filter";
import gridIcon from "@public/img/grid.svg"
import closeIcon from "@public/img/close.svg"
import chevronDownIcon from "@public/img/chevron-down2.svg"
import { WonmovContext } from "../../context/app-context";
import { MenuItem } from "@/entry/server/app";
import "@/styles/mobile-menu.css";

export default function MobileMenu() {
    const { isSearchFilterOpen, setIsSearchFilterOpen } = useContext<AppContextType>(WonmovContext);
    const pathname = useLocation().pathname;
    const [isDrawerMenuOpen, setIsDrawerMenuOpen] = useState(false);

    const closeDrawer = () => setIsDrawerMenuOpen(false);

    return (
        <>
            <ButtomNavigation
                isOpenMenu={isDrawerMenuOpen}
                isOpenSearch={isSearchFilterOpen}
                onOpenMenu={() => setIsDrawerMenuOpen(true)}
                onOpenSearch={() => setIsSearchFilterOpen(!isSearchFilterOpen)}
            />

            {pathname !== '/' && <SearchFilter showAlwaysOnDesktop={false} />}

            <DrawerMenu isOpen={isDrawerMenuOpen} onClose={closeDrawer} />
        </>
    );
}

function ButtomNavigation({ isOpenMenu, isOpenSearch, onOpenMenu, onOpenSearch }: { isOpenMenu: boolean, isOpenSearch: boolean, onOpenMenu: () => void, onOpenSearch: () => void }) {
    const pathname = useLocation().pathname;
    const isActive = (href: string) => pathname === href;
    return (
        <nav className="mobile-bottom-nav">
            <table className="mobile-bottom-nav__table">
                <tbody>
                    <tr>
                        <td className="mobile-bottom-nav__cell">
                            <Link to='/' className={`mobile-bottom-nav__item${isActive('/') ? ' is-active' : ''}`}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.11115 17.5C4.12931 17.5 3.33337 16.6829 3.33337 15.675V8.33986C3.33337 7.78547 3.57887 7.26114 4.00058 6.91481L8.88947 2.89991C9.53875 2.3667 10.4613 2.3667 11.1106 2.8999L15.9995 6.91481C16.4212 7.26113 16.6667 7.78547 16.6667 8.33986V15.675C16.6667 16.6829 15.8708 17.5 14.8889 17.5H5.11115Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M7.91663 17.5V12.9167C7.91663 11.9962 8.66282 11.25 9.58329 11.25H10.4166C11.3371 11.25 12.0833 11.9962 12.0833 12.9167V17.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <span>خانه</span>
                            </Link>
                        </td>

                        <td className="mobile-bottom-nav__cell">
                            <button type="button" className={`mobile-bottom-nav__item mobile-bottom-nav__btn${isOpenMenu ? ' is-active' : ''}`} onClick={onOpenMenu}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.25 14.3809C11.25 12.9078 11.25 12.1712 11.7076 11.7135C12.1653 11.2559 12.9019 11.2559 14.375 11.2559C15.8481 11.2559 16.5847 11.2559 17.0424 11.7135C17.5 12.1712 17.5 12.9078 17.5 14.3809C17.5 15.854 17.5 16.5906 17.0424 17.0482C16.5847 17.5059 15.8481 17.5059 14.375 17.5059C12.9019 17.5059 12.1653 17.5059 11.7076 17.0482C11.25 16.5906 11.25 15.854 11.25 14.3809Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M2.5 14.3809C2.5 12.9078 2.5 12.1712 2.95765 11.7135C3.41529 11.2559 4.15186 11.2559 5.625 11.2559C7.09814 11.2559 7.83471 11.2559 8.29235 11.7135C8.75 12.1712 8.75 12.9078 8.75 14.3809C8.75 15.854 8.75 16.5906 8.29235 17.0482C7.83471 17.5059 7.09814 17.5059 5.625 17.5059C4.15186 17.5059 3.41529 17.5059 2.95765 17.0482C2.5 16.5906 2.5 15.854 2.5 14.3809Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M11.25 5.625C11.25 4.15186 11.25 3.41529 11.7076 2.95765C12.1653 2.5 12.9019 2.5 14.375 2.5C15.8481 2.5 16.5847 2.5 17.0424 2.95765C17.5 3.41529 17.5 4.15186 17.5 5.625C17.5 7.09814 17.5 7.83471 17.0424 8.29235C16.5847 8.75 15.8481 8.75 14.375 8.75C12.9019 8.75 12.1653 8.75 11.7076 8.29235C11.25 7.83471 11.25 7.09814 11.25 5.625Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M2.5 5.625C2.5 4.15186 2.5 3.41529 2.95765 2.95765C3.41529 2.5 4.15186 2.5 5.625 2.5C7.09814 2.5 7.83471 2.5 8.29235 2.95765C8.75 3.41529 8.75 4.15186 8.75 5.625C8.75 7.09814 8.75 7.83471 8.29235 8.29235C7.83471 8.75 7.09814 8.75 5.625 8.75C4.15186 8.75 3.41529 8.75 2.95765 8.29235C2.5 7.83471 2.5 7.09814 2.5 5.625Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <span>دسته بندی</span>
                            </button>
                        </td>

                        <td className="mobile-bottom-nav__cell">
                            <button type="button" id="search-button" className={`mobile-bottom-nav__item mobile-bottom-nav__btn${isOpenSearch ? ' is-active' : ''}`} onClick={e => {
                                e.stopPropagation();
                                onOpenSearch();
                            }}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.0773 14.0999L16.6441 16.6667M15.9034 9.65093C15.9034 13.14 13.0844 15.9685 9.60709 15.9685C6.12974 15.9685 3.31079 13.14 3.31079 9.65093C3.31079 6.16182 6.12974 3.33334 9.60709 3.33334C13.0844 3.33334 15.9034 6.16182 15.9034 9.65093Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <span>جستجو</span>
                            </button>
                        </td>

                        <td className="mobile-bottom-nav__cell">
                            <Link to='/competition' className={`mobile-bottom-nav__item${isActive('/competition') ? ' is-active' : ''}`}>
                                <svg fill="currentColor" width="20" height="20" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M29,4h-6c-0.022,0-0.04,0.011-0.061,0.012c-0.651-1.124-1.367-1.743-1.419-1.786C21.341,2.08,21.117,2,20.886,2h-9.773 c-0.231,0-0.455,0.08-0.633,0.227c-0.052,0.043-0.769,0.662-1.419,1.786C9.04,4.011,9.022,4,9,4H3C2.715,4,2.444,4.121,2.255,4.333 c-0.19,0.212-0.28,0.495-0.249,0.777c0.34,3.061,2.567,8.938,8.514,9.775c0.648,0.924,1.413,1.858,2.311,2.803 c0.048,0.051,0.112,0.078,0.168,0.117V20h-2c-0.552,0-1,0.447-1,1v3H8c-0.552,0-1,0.447-1,1v4c0,0.553,0.448,1,1,1h16 c0.552,0,1-0.447,1-1v-4c0-0.553-0.448-1-1-1h-2v-3c0-0.553-0.448-1-1-1h-2v-2.194c0.057-0.039,0.12-0.067,0.168-0.117 c0.897-0.944,1.662-1.879,2.311-2.803c5.947-0.837,8.175-6.714,8.514-9.775c0.032-0.282-0.059-0.565-0.249-0.777 C29.556,4.121,29.285,4,29,4z M4.203,6h4.056C8.143,6.453,8.049,6.931,8.016,7.463c-0.101,1.611,0.258,3.279,1.068,4.994 C5.853,11.149,4.629,7.774,4.203,6z M23,28H9v-2h2h10h2V28z M20,24h-8v-2h2h4h2V24z M15,20v-2h2v2H15z M18.01,16H18h-4h-0.01 c-2.783-3.019-4.122-5.833-3.98-8.369C10.117,5.707,11.065,4.479,11.514,4h8.971c0.452,0.482,1.398,1.709,1.505,3.632 C22.131,10.167,20.792,12.981,18.01,16z M22.92,12.449c0.808-1.712,1.165-3.378,1.064-4.987C23.951,6.931,23.857,6.453,23.742,6 h4.047C27.352,7.765,26.111,11.136,22.92,12.449z"></path>
                                </svg>
                                <span>مسابقه</span>
                            </Link>
                        </td>

                        <td className="mobile-bottom-nav__cell">
                            <Link to='/profile' className={`mobile-bottom-nav__item${isActive('/profile') ? ' is-active' : ''}`}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.5 20.5C19.0246 11.1667 4.97538 11.1667 4.5 20.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <circle cx="12" cy="8" r="3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <span>پروفایل</span>
                            </Link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </nav>
    );
}

function DrawerMenu({ isOpen, onClose }: { isOpen: boolean, onClose: () => void }) {
    const { menuData } = useContext(WonmovContext);

    return (
        <div
            className={`mobile-drawer-overlay ${isOpen ? 'is-open' : 'is-closed'}`}
            onClick={onClose}
            dir="rtl"
            aria-hidden={!isOpen}
        >
            <div
                className="mobile-drawer-panel"
                onClick={e => e.stopPropagation()}
            >
                <div className="mobile-drawer-panel__header">
                    <img src={gridIcon} alt="" className="mobile-drawer-panel__logo" />
                    <span className="text-lg font-bold">دسته‌بندی‌ها</span>
                    <img
                        src={closeIcon}
                        alt="بستن"
                        className="mobile-drawer-panel__close"
                        onClick={onClose}
                        role="button"
                    />
                </div>

                <div className="mobile-drawer-panel__body">
                    <DrawerMenuListItem label="دسته‌بندی‌ها" items={menuData?.sections || []} onNavigate={onClose} />
                    <DrawerMenuListItem label="ژانرها" items={menuData?.genres || []} onNavigate={onClose} />
                    <DrawerMenuListItem label="کشورها" items={menuData?.countries || []} onNavigate={onClose} />
                    <DrawerMenuListItem label="زبان‌ها" items={menuData?.languages || []} onNavigate={onClose} />

                    <Link to="/actors" className="mobile-drawer-link bg-lime-400 rounded-lg py-2.5 px-4 w-full" onClick={onClose}>
                        <span className="text-zinc-900">بازیگران</span>
                    </Link>
                    <Link to="/about" className="mobile-drawer-link bg-lime-400 rounded-lg py-2.5 px-4 w-full" onClick={onClose}>
                        <span className="text-zinc-900">درباره ما</span>
                    </Link>
                    <Link to="/competition" className="mobile-drawer-link bg-lime-400 rounded-lg py-2.5 px-4 w-full" onClick={onClose}>
                        <span className="text-zinc-900">مسابقه</span>
                    </Link>
                </div>
            </div>
        </div>
    );
}

function DrawerMenuListItem({ label, items, onNavigate }: { label: string, items: MenuItem[], onNavigate: () => void }) {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <button type="button" className="mobile-drawer-section-btn bg-lime-400 rounded-lg py-2.5 px-4 w-full" onClick={() => setIsOpen(!isOpen)}>
                <span className="text-zinc-900">{label}</span>
                <img
                    src={chevronDownIcon}
                    alt=""
                    className={`mobile-drawer-chevron ${isOpen ? 'is-open' : ''}`}
                />
            </button>

            {isOpen && (
                <div className="mobile-drawer-list">
                    {items.map((item) => (
                        <Link
                            to={item.url}
                            key={item.label}
                            className="mobile-drawer-list__item"
                            onClick={onNavigate}
                        >
                            <span>{item.label}</span>
                        </Link>
                    ))}
                </div>
            )}
        </>
    );
}
